<template>
    <div>
      <div :class=" maxWidth ? 'select-box ajustar' :'select-box'">
        <div :style="clase" :class="active ? 'active' : ''" class="options-container">
            <v-date-picker  v-model="date" :min="minDate"  no-title scrollable> </v-date-picker>
        </div>
        <div :style="clase" @click="handleActive" class="selected">{{ selectedItem }}</div>
      </div>
    </div>
  </template>
  
  <script>
  import moment from 'moment';
  export default {
    props: {
      items: {
        type: Array,
        default:()=>  [
          { value: 0, text: "opcion 1" },
          { value: 1, text: "opcion 2" },
          { value: 2, text: "opcion 3" },
          { value: 3, text: "opcion 4" },
        ],
      },
      placeholder:{
        type:String,
        default:"Fecha"
      },
      minDate:{
        type:String,
        default:''
      },
      format:{
        type:String,
        default:"false"
      },
      clase:{
        type:String,
        default:''
      },
      maxWidth:{
        type:Boolean,
        default:false
      },
    },
    emits:["fecha"],
    data() {
      return {
        active: false,
        selectedItem:this.placeholder,
        date:""
      };
    },
    methods:{
      handleActive(){
          this.active = !this.active
      },
      handleSelect(item){
         this.selectedItem = item
         this.active = false
         this.$emit("status",item.value)
      },
      formatDate(fecha){
        const meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"]
        const [año,mes,dia] = fecha.split("-")
        console.log(año)
        const indice = Number(mes) - 1
        return `${dia} ${meses[indice]}`
      },
      dateFormat(fecha){
        return moment(fecha).format(this.format)
      }
    },
    watch:{
      selectedItem(value){
          console.log(value)
      },
      date(value){
        const placeholder = this.format == "false" ? this.formatDate(value) : this.dateFormat(value)
        this.selectedItem = placeholder
        this.$emit("fecha",value)
        this.active = false
      }
    }
  };
  </script>
  
  <style scoped>
  * {
    margin: 0;
    box-sizing: border-box;
  }
  


  .select-box {
    display: flex;
    flex-direction: column;
    /* width: 100%; */
    width: 140px;
    /* overflow: hidden; */
    text-overflow: ellipsis;
    position: relative;
  }
  
  .select-box.ajustar{
    width: 100% !important;
  }
  .select-box .options-container {
    background-color: #ffff;
    border: 1px solid #0a4f9c;
    max-height: 0;
    width: 100%;
    opacity: 0;
    transition: all 0.4s;
    border-radius: 4px;
    overflow: hidden;
    order: 1;
    position: absolute;
    top: 35px;
    z-index: 700;
  }
  
  
  
  
  .selected {
    background-color: #ffff;
    border: 1px solid #0a4f9c;
    border-radius: 4px;
    /* margin-bottom: 4px; */
    color: #0a4f9c;
    order: 0;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    /* z-index: 600; */
    text-align: start;
  }
  
  .selected::after {
    content: "";
    background-image: url("../../assets/imgs/Arrow.svg");
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    height: 100%;
    width: 15px;
    top: 10px;
    right: 10px;
    transition: all 0.4s;
  }
  
  .select-box .option,
  .selected {
    padding: 4px 8px;
    cursor: pointer;
  }
  
  /* .selected + .options-container.active{
      border-bottom: none;
  } */
  
  .select-box .options-container.active {
    max-height: min-content;
    width: min-content;
    opacity: 1;
    overflow-y: scroll;
    /* border-top: none; */
  }
  
  .select-box .options-container.active + .selected::after{
      transform: rotateX(180deg);
      top: -10px;
  }
  
  /* .select-box .options-container::-webkit-scrollbar {
    width: 8px;
    background-color: #0d141f;
    border-radius: 0 8px 8px 0;
  }
  
  .select-box .options-container::-webkit-scrollbar-thumb {
    background-color: #525861;
    border-radius: 0 8px 8px 0;
  } */
  
  .select-box .option:hover {
    background-color: #e5e5e5;
  }
  
  .select-box label {
    cursor: pointer;
  }
  
  .select-box .option .radio {
    display: none;
  }
  </style>
  